const _none = 1
const _tight = 1.2
const _snug = 1.4
const _normal = 1.5
const _relaxed = 1.618
const _wide = 1.75
const _loose = 2
const config = { "none": _none, "tight": _tight, "snug": _snug, "normal": _normal, "relaxed": _relaxed, "wide": _wide, "loose": _loose,  }
export { config as default, _none, _tight, _snug, _normal, _relaxed, _wide, _loose }